const DARK_MODE_KEY = 'IS_DARK_MODE_SET';

export const getDarkModeStatus = () =>
  !!localStorage.getItem(DARK_MODE_KEY) &&
  localStorage.getItem(DARK_MODE_KEY) === 'true';

export const storeDarkModeStatus = (isDarkModeActive: boolean) => {
  localStorage.setItem(DARK_MODE_KEY, isDarkModeActive.toString());
};
